import { EmbeddableCatalogBrowserWithoutRouter } from '@tableau/data-catalog-client-components';
import * as React from 'react';
import { SiteUrlsProps } from '../app/selectors/SiteUrlsSelectors';
import { ConnectedSpaceInfoProvider } from '../app/spaces/RouterHelpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../app/state/SpaceInfo';
import { catalogFeatureFlagsAdapter } from '../catalog/CatalogFeatureFlagsAdapter';
import { ReactDirectiveProps } from '../ts/directives/reactDirectiveFactory';
import { FeatureFlags } from '../ts/FeatureFlags';
import { DatabaseContentType, TableContentType } from '../ts/models/ContentTypes';
import { CatalogApiRequests } from './CatalogApiRequests';
import { DataCatalogUIActionsService } from '../ts/services/DataCatalogUIActionsService';
import { catalogApolloClient } from './CatalogApolloClient';
import { CatalogBrowserSubspaceExplorer } from './CatalogBrowserSubspaceExplorer';
import { registerErrorStore, unregisterErrorStore } from './CatalogErrorReporterService';
import { DatabaseDefinition } from '../ts/models/contentDefinitions/DatabaseDefinition';
import { TableDefinition } from '../ts/models/contentDefinitions/TableDefinition';
import { hideLaunchEditOnMobile } from '../app/utils/MobileHelper';

type CatalogBrowserHostOwnProps = ReactDirectiveProps;

export type ConnectedCatalogBrowserHostProps = SiteUrlsProps & {
  readonly areUsersVisible: boolean;
};

type CatalogBrowserHostProps =
  ConnectedCatalogBrowserHostProps &
  CatalogBrowserHostOwnProps;


class CatalogBrowserHost extends React.Component<CatalogBrowserHostProps> {
  private spaceInfo: SpaceInfo = {
    spaceType: 'catalog',
    subspaceName: undefined,
    item: SpaceItemForNonEntitySpace
  };

  private renderDatabasesExplorer = (routeLocationSearch: string): JSX.Element => {
    return <CatalogBrowserSubspaceExplorer
      key="database"
      subspaceName="database"
      routeLocationSearch={routeLocationSearch}
      angularContext={this.props.angularContext}
      contentDefinition={DatabaseDefinition}
      contentType={DatabaseContentType}
    />;
  }

  private renderTablesExplorer = (routeLocationSearch: string): JSX.Element => {
    return <CatalogBrowserSubspaceExplorer
      key="table"
      subspaceName="table"
      routeLocationSearch={routeLocationSearch}
      angularContext={this.props.angularContext}
      contentDefinition={TableDefinition}
      contentType={TableContentType}
    />;
  }

  public render(): JSX.Element {
    return (
      <div className="tb-fill" style={{ display: 'flex' }}>
        <ConnectedSpaceInfoProvider spaceInfo={this.spaceInfo}>
          <EmbeddableCatalogBrowserWithoutRouter
            client={catalogApolloClient}
            siteUrls={this.props.urls}
            apiRequests={CatalogApiRequests}
            uiActions={DataCatalogUIActionsService.instance()}
            featureFlags={catalogFeatureFlagsAdapter()}
            renderDatabasesExplorer={this.renderDatabasesExplorer}
            renderTablesExplorer={this.renderTablesExplorer}
            registerErrorStore={registerErrorStore}
            unregisterErrorStore={unregisterErrorStore}
            newWorkbookFromCatalog={FeatureFlags.newWorkbookFromCatalog && !hideLaunchEditOnMobile()}
            areUsersVisible={this.props.areUsersVisible}
          />
        </ConnectedSpaceInfoProvider>
      </div>
    );
  }
}

export const WrappedCatalogBrowserHost = CatalogBrowserHost;
